module.exports = __webpack_public_path__ + "static/winter-olympics-69133d3a560769271f97bd1785061ed2.gif";